import React, {Component} from 'react';

export default class About extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    componentDidMount(){
        //alert(JSON.stringify(this.props.history));
    }
    render(){
        const sta={
            color: 'blue',
            bottom: '0px',
            position: 'fixed',
            margin: '0 auto !important',
            left: '40%'
        }
        return (
        <div><h2>This is About Page</h2>
        <p><strong><u>Contact at:</u> </strong><a href="mailto:claudiu.vasile@gmail.com?Subject=Hello%20React%20Material">Mail to: claudiu.vasile@gmail.com</a></p>

        <div className="mx-auto text-center" style={sta}>&copy; 2019 - React Sopcast</div>
        </div>
        );
    }
}